import React from "react";
import styled from "styled-components";
import { Upload, Icon } from "antd";
import { UploadFile } from "antd/lib/upload/interface";
import { RcFile } from "antd/lib/upload";

const Wrapper = styled.div`
  width: 120%;

  .ant-upload.ant-upload-select-picture-card {
    width: 80px;
    height: 80px;
  }

  .ant-upload-list-picture-card .ant-upload-list-item {
    width: 80px;
    height: 80px;
  }

  .ant-upload-list-picture-card .ant-upload-list-item-thumbnail {
    height: 36px;
  }

  .ant-upload-list-picture-card .anticon-picture + .ant-upload-list-item-name {
    font-size: 10px;
  }

  .ant-upload-list-picture-card {
    float: none;
  }
`;

const Header = styled.h2`
  color: #061a32;
  font-size: 14px;
  line-height: 17px;
  font-weight: 400;
  margin: 12px 0;
`;

interface DocumentUploadProps {
  handleBeforeUpload: (file: RcFile, FileList: RcFile[]) => boolean;
  onRemove: (file: UploadFile) => void;
  fileList: RcFile[];
  title: string;
}

function DocumentUpload({
  handleBeforeUpload,
  onRemove,
  fileList,
  title
}: DocumentUploadProps): JSX.Element {
  const uploadButton = (
    <div>
      <Icon type="plus" />
      <div className="ant-upload-text">Upload</div>
    </div>
  );

  return (
    <Wrapper>
      <Header>{title}</Header>
      <Upload
        listType="picture-card"
        fileList={fileList}
        onRemove={onRemove}
        beforeUpload={handleBeforeUpload}
        showUploadList={{ showPreviewIcon: false, showRemoveIcon: true }}
        multiple={true}
      >
        {uploadButton}
      </Upload>
    </Wrapper>
  );
}

export default DocumentUpload;
